<lib-searchmask [showSearchMask]="showSearchMask" (valueChanged)="setChangeDetected($event)"></lib-searchmask>



<div class="container my-5">

    <app-pim-notification phase="Availability"></app-pim-notification>

    <a id="multiRoomScrollAnchor"></a>

    @if (av && (noRatesWithBookingCode && !settings.get('availability.hideOtherRoomsWhenCodeUsed'))) {
        <p-message severity="error" class="mb-3 d-block">
            {{"av.noBookingCodeFound"|translate:{value: noRatesWithBookingCode} }}
        </p-message>
    }

    <!-- <app-breadcrumb></app-breadcrumb>
 -->
    <div class="availability-rooms row" [attr.data-testid]="'availability-rooms-container'">
        @if (changeDetected){
            <div class="sm-changed-overlay" [attr.data-testid]="'change-detected-overlay'">
                {{"av.SearchChanged"|translate}}
            </div>
        }

        @if (roomCount > 1 && searchParams && !noAvInSomeIndex) {
            <div class="col-12">
                <app-multiroom-navigator [activeRoom]="activeAvIndex" [searchParams]="searchParams" (changeRoomIndex)="handleRoomIndexChange($event)"></app-multiroom-navigator>
            </div>
        }

        <div class="col-12">
            <div class="row">
                @if (categoriesInSettings && categoriesInSettings.length > 0) {
                    <div class="av-categories" [attr.data-testid]="'categories-container'">
                        @for (category of categoriesInSettings; track $index) {
                            <p-button [outlined]="activeCategory.value != category.value" (click)="changeCategory(category)" [attr.data-testid]="'select-category-' + category.name">{{category.name}}</p-button>
                        }
                    </div>
                }
            </div>

            <div class="row">
                <div class="col-9 col-md-10">
                    @if (!noAvInSomeIndex && (av && av[activeAvIndex]?.length > 0)) {
                        @if (categoriesInSettings && categoriesInSettings.length > 0) {
                            @if (activeCategory.value == 'ALL') {
                                <h2 class="my-3">{{'av.OurRooms'|translate}}</h2>

                                <p class="my-2">{{'av.PleaseSelectARoom'|translate}}</p>
                            }
                            @else {
                                <h2 class="my-3">{{"av.OurRoomsInCategory"|translate}} <span class="av-phase-category-name">{{activeCategory.name}}</span></h2>
                            }

                        }
                        @else {
                            <h2 class="my-3">{{'av.OurRooms'|translate}}</h2>
                            <p class="my-2">{{'av.PleaseSelectARoom'|translate}}</p>
                        }
                    }

                </div>
                <div class="col-3 col-md-2 av-hotel-details-button-wrap">
                    <p-button (click)="openHotelDetails()" [attr.data-testid]="'hotel-details-open'">{{ hotelDetailsLink?.label ?? ("av.HotelDetails"|translate) }}</p-button>
                </div>
            </div>


            <!-- If availability is returned -->
            @if (av) {

                 @if (noRatesWithBookingCode && settings.get('availability.hideOtherRoomsWhenCodeUsed')) {

                    <div class="av-error">
                        <div class="av-error-emoji" style="font-size:3rem">😔</div>
                        <p [innerHTML]="'av.noBookingCodeFound' | translate:{value: noRatesWithBookingCode}"></p>
                    </div>
                }

                @else if (noAvInSomeIndex) {
                    <div class="av-error">
                        <div class="av-error-emoji" style="font-size:3rem">😔</div>
                        @if (sameDayError) {
                            @if (settings.get('availability.sameDayReservationsMaxDays') || settings.get('availability.sameDayReservationsMaxHour')) {
                                <p [innerHTML]="'av.noRoomsDaysAndHoursRestrictionError' | translate"></p>
                            } 
                        }
                        @else if (bookingCutoffError) {
                            <p [innerHTML]="'av.noRoomsBookingCutoffError' | translate: {value: settings.get('availability.bookingCutoffDays')}"></p>
                        }
                        @else {
                            @if (av.length > 1) { <!-- multiroom -->


                                {{"av.noRoomsFoundMultiroomError"|translate:{value: noAvInSomeIndex.roomIndex + 1} }}<br><br>
                                {{noAvInSomeIndex.searchParams.adults}}

                                @if (noAvInSomeIndex.searchParams.adults > 1) { {{"sm.adults" | translate}} } @else{ {{"sm.adult" | translate}} }@if(noAvInSomeIndex.searchParams.children > 0){, {{noAvInSomeIndex.searchParams.children}}

                                @if (noAvInSomeIndex.searchParams.children == 1){ {{"sm.child" | translate}} } @else{ {{"sm.children" | translate}} }}

                            }
                            @else {

                                <p [innerHTML]="'av.noRoomsFoundError' | translate"></p>
                            }
                        }

                        @if (allRoomsEmpty && searchParams) {
                            <app-alternative-availability [searchParams]="searchParams" />
                        }
                    </div>
                }



                @else if (categoriesInSettings && categoriesInSettings.length > 0 && (!availableCategories[activeAvIndex]?.includes(activeCategory.value) && activeCategory.value != 'ALL')) {
                    <div class="av-error">
                        <div class="av-error-emoji" style="font-size:3rem">😔</div>
                        <p [innerHTML]="'av.noRoomsFoundInThisCategoryError' | translate"></p>
                    </div>

                }



                @else {

                    @if (hasMembershipTiers && settings.get('externalLoginProvider') == 'sfc') {
                        <p-message severity="info" class="mb-3 d-block">
                            <div class="d-flex align-items-center gap-2">
                                <span class="material-symbols-outlined">
                                    vpn_key
                                </span>
                                <span [innerHTML]="'av.membershipsInfoMessageSfc' | translate"></span>
                            </div>
                        </p-message>
                    }

                    <!-- Loop through rooms in per multiroom -->
                    <div class="rooms-container" [class.av-style-2]='settings.get("availability.presentationStyle") == 2' [attr.data-testid]="'rooms-container'">
                        @for (room of av[activeAvIndex]; track $index) {
                            @if (!categoriesInSettings || (getRoomCategory(room.roomrates[0].room) == activeCategory.value || activeCategory.value == 'ALL')) {

                               

                                    @switch (settings.get("availability.presentationStyle")) {
                                        @case (2) {
                                            <app-availability-room-2
                                                (roomSelected)="handleRoomSelected($event)"
                                                (moreRatesButtonClicked)="handleOpenMoreRates($event)"
                                                (readmoreButtonClicked)="handleOpenReadmore($event)"
                                                [roomData]="room"
                                                [isMultiRoom]="roomCount > 1"
                                                [class.cardCount2]="settings.get('availability.cardCountPerRow') == '2'"
                                                [class.cardCount3]="settings.get('availability.cardCountPerRow') == '3'"
                                                [class.cardCount4]="settings.get('availability.cardCountPerRow') == '4'"
                                                [attr.data-testid]="'availability-room-2'"
                                                [roomIndex]="$index"
                                            ></app-availability-room-2>

                                        }
                                        @default {
                                            <app-availability-room-1 [@fadeInOut]
                                                (roomSelected)="handleRoomSelected($event)"
                                                (moreRatesButtonClicked)="handleOpenMoreRates($event)"
                                                (readmoreButtonClicked)="handleOpenReadmore($event)"
                                                [roomData]="room"
                                                [isMultiRoom]="roomCount > 1"
                                                [attr.data-testid]="'availability-room-1'"
                                                [roomIndex]="$index"
                                            ></app-availability-room-1>
                                        }
                                    }
                                
                            }



                        }
                    </div>

                    <app-more-rates-popup
                        [visible]="moreRatesPopupContent != null"
                        [roomData]="moreRatesPopupContent"
                        (onHideRoomPopup)="handleCloseMoreRates()"
                        (roomSelected)="handleRoomSelected($event)"
                    />

                    <app-availability-room-readmore
                        [visible]="readmoreContent != null"
                        [roomData]="readmoreContent"
                        [hotelCode]="searchParams?.hotelCode ?? '1'"
                        (onHideReadmore)="handleCloseReadmore()"
                    ></app-availability-room-readmore>

                }

            }
            @else {
                @switch (settings.get("availability.presentationStyle")) {
                    @case (2) {
                        <div class="room2-skeleton-container">
                            @for (item of cardCountPerRowArray; track $index) {
                                <app-availability-room-2-skeleton
                                [class.cardCount2]="settings.get('availability.cardCountPerRow') == '2'"
                                [class.cardCount3]="settings.get('availability.cardCountPerRow') == '3'"
                                [class.cardCount4]="settings.get('availability.cardCountPerRow') == '4'"/>
                            }


                        </div>

                    }
                    @default {
                        <app-availability-room-1-skeleton />
                        <app-availability-room-1-skeleton />
                    }
                }

            }


        </div>


    </div>


</div>

<hotel-details-popup
    [visible]="hotelDetailsOpened"
    [hotelData]="hotelData"
    [contactDetails]="contactDetails"
    [hotelCode]="this.searchParams?.hotelCode"
    (onHide)="handleCloseHotelDetails()"

></hotel-details-popup>

<app-external-login-popup
    [externalLoginProvider]="settings.get('externalLoginProvider')"
    [visible]="gotoExternalLoginConfrmationVisible"
    (onHide)="gotoExternalLoginConfrmationVisible = false"
    (proceedToExternalLogin)="proceedToExternalLogin()"
></app-external-login-popup>

@if (externalLoginData) {
    <div class="external-login-info" [class.full]="showLoginData">
        <div class="login-successful-message">
            <span [class.d-none]="!showLoginData">{{'av.loginSuccessful'|translate}}</span>
            <p-button icon="fa" rounded="true" text="true" (click)="showLoginData = !showLoginData">
                <span class="material-symbols-outlined">
                account_circle
                </span>
            </p-button>
            
        </div>
        <div class="external-login-loggedin" [class.d-none]="!showLoginData">{{'av.loginEmail'|translate}}:<br><span class="login-data">{{externalLoginData.email}}</span></div>
        <div class="external-login-membernumber" [class.d-none]="!showLoginData">{{'av.membershipNumber'|translate}}:<br><span class="login-data">{{externalLoginData.membershipNumber}}</span></div>

    </div>
}
